export default __webpack_public_path__ + "static/media/privacyBlack.2503d862.svg";